import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

import { BACKEND_URL } from '../config/api';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    } else {
      navigate('/employer/dashboard');
    }
  }, [sessionId]);

  const pollPaymentStatus = async (attempts = 0) => {
    const maxAttempts = 5;
    if (attempts >= maxAttempts) {
      toast.error('Payment status check timed out');
      setChecking(false);
      return;
    }

    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/payments/checkout/status/${sessionId}`,
        { withCredentials: true }
      );

      if (response.data.payment_status === 'paid') {
        toast.success('Subscription activated!');
        setChecking(false);
        setTimeout(() => navigate('/employer/dashboard'), 3000);
      } else if (response.data.status === 'expired') {
        toast.error('Payment session expired');
        setChecking(false);
      } else {
        setTimeout(() => pollPaymentStatus(attempts + 1), 2000);
      }
    } catch (error) {
      toast.error('Error checking payment status');
      setChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-4" data-testid="subscription-success-page">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        {checking ? (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500 mx-auto mb-6"></div>
            <h2 className="text-2xl font-bold text-slate-900 mb-2" data-testid="checking-status-title">Processing Payment</h2>
            <p className="text-slate-600">Please wait while we verify your subscription...</p>
          </>
        ) : (
          <>
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-6" data-testid="success-icon" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2" data-testid="success-title">Subscription Active!</h2>
            <p className="text-slate-600 mb-6">Your subscription has been activated. You can now search and contact tradespeople.</p>
            <button
              onClick={() => navigate('/employer/dashboard')}
              className="btn-accent w-full"
              data-testid="go-to-dashboard-btn"
            >
              Go to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}
